import { styled } from "@stitches/react";
import * as Avatar from "@radix-ui/react-avatar";

const StyledAvatar = styled(Avatar.Root, {
  display: "block",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "middle",
  userSelect: "none",
  width: 72,
  height: 72,
  marginRight: "1rem",
});

const StyledImage = styled(Avatar.Image, {
  width: 72,
  height: 72,
  borderRadius: 99999,
  objectFit: "cover",
});

const StyledFallback = styled(Avatar.Fallback, {
  width: 72,
  height: 72,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "dodgerblue",
  borderRadius: 99999,
  fontWeight: "bold",
});

export const TwitterAvatar = ({ picture, name }) => (
  <StyledAvatar>
    <StyledImage loading="lazy" src={picture} alt={`Avatar ${name}`} />
    <StyledFallback>{name.slice(0, 2).toUpperCase()}</StyledFallback>
  </StyledAvatar>
);
